<template>
  <div class="page_context" v-if="pageShow">
    <div class="menu_context">
      <div v-for="(menu,index) in currMenu.button" class="item_list">
        <div class="item_row">
          <el-select v-if="!menu.sub_button" v-model="menu.type" class="select_type">
            <el-option v-for="item in menuTypes" :label="item.name" :value="item.value"></el-option>
          </el-select>

          <el-input v-model="menu.name" maxlength="4" class="input_name" placeholder="输入菜单名称[最多4字]"
            :suffix-icon="menu.type=='media_id'&&menu['media_id']?'el-icon-success':''"></el-input>
          <div class="btn_icon" title="添加子菜单" @click="addSubMenu(menu)"><i class="el-icon-circle-plus"></i></div>
          <div class="btn_icon" title="删除菜单" @click="delMenu(currMenu.button,index)"><i class="el-icon-remove"></i>
          </div>
          <div v-if="!menu.sub_button">
            <el-input v-if="menu.type=='view'||menu.type=='miniprogram'" v-model="menu.url" class="input_url"
              placeholder="输入url地址"></el-input>
            <el-button v-else-if="menu.type=='media_id'"
              @click="selectMsg(menu)">{{menu['media_id']?'重选普通消息':'选取普通消息'}}</el-button>
            <el-button v-else-if="menu.type=='article_id'||menu.type=='article_view_limited'"
              @click="selectNewsMsg(menu)">选取图文消息</el-button>
            <el-input v-else v-model="menu.value" class="input_url"></el-input>
          </div>
        </div>
        <div v-if="menu.sub_button" class="sub_item_list">
          <div class="item_row" v-for="(sub_menu,index2) in menu.sub_button">
            <el-select v-model="sub_menu.type" class="select_type">
              <el-option v-for="item in menuTypes" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <el-input v-model="sub_menu.name" maxlength="4" class="input_name" placeholder="输入菜单名称[最多8字]"
              :suffix-icon="sub_menu.type=='media_id'&&sub_menu['media_id']?'el-icon-success':''"></el-input>

            <el-input v-if="sub_menu.type=='view'||sub_menu.type=='miniprogram'" v-model="sub_menu.url"
              class="input_url" placeholder="输入url地址"></el-input>
            <el-button v-else-if="sub_menu.type=='media_id'"
              @click="selectMsg(sub_menu)">{{sub_menu['media_id']?'重选普通消息':'选取普通消息'}}</el-button>
            <el-button v-else-if="sub_menu.type=='article_id'||sub_menu.type=='article_view_limited'"
              @click="selectNewsMsg(sub_menu)">选取图文消息</el-button>
            <el-input v-else v-model="sub_menu.value" class="input_url" placeholder="输入url地址"></el-input>
            <div class="btn_icon" title="删除菜单" @click="delMenu(menu.sub_button,index2)"><i class="el-icon-remove"></i>
            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="opr_btn">
      <el-button @click="addMenu" icon="el-icon-circle-plus">添加一级菜单</el-button>
      <el-button type="primary" size="medium" @click="createMenu">发布</el-button>
    </div>

    <el-dialog title="选取消息" :visible.sync="msgShow" width="820px">
      <el-tabs v-model="currTab" @tab-click="(tab)=>{getMaterialList(tab.name)}">
        <el-tab-pane v-if="materialInfo.image_count>0"
          :label="materialInfo.image_count?'图片('+materialInfo.image_count+')':'图片'" name="image"></el-tab-pane>
        <el-tab-pane v-if="materialInfo.video_count>0"
          :label="materialInfo.video_count?'视频('+materialInfo.video_count+')':'视频'" name="video"></el-tab-pane>
        <el-tab-pane v-if="materialInfo.voice_count>0"
          :label="materialInfo.voice_count?'语音('+materialInfo.voice_count+')':'语音'" name="voice"></el-tab-pane>
        <el-tab-pane v-if="materialInfo.news_count>0"
          :label="materialInfo.news_count?'图文('+materialInfo.news_count+')':'图文'" name="news"></el-tab-pane>
      </el-tabs>

      <el-radio-group key="msg" v-model="currMediaId">
        <el-table :data="materialList" :height="640">
          <el-table-column label="选择" width="55">
            <template slot-scope="scope">
              <el-radio :label="scope.row.media_id">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="名称" prop="name" width="460">
            <template slot-scope="scope">
              <span v-if="currTab!='news'">{{scope.row.name}}</span>
              <span v-else>{{scope.row.content.news_item[0].title}}</span>
            </template>
          </el-table-column>
          <!-- 	 <el-table-column
				  label="地址"
				  width="360">
				  <template slot-scope="scope">
				  <div>
					  <el-image  v-if="currTab=='image'" :scr="scope.row.url"  style="width: 100px; height: 100px"></el-image>
					  <video v-else :scr="scope.row.cover_url"></video>
				  </div>
				  </template>
			</el-table-column> -->
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div>
                <a v-if="currTab=='news'" target="_blank" :href="scope.row.content.news_item[0].url">点击查看</a>
                <a v-else target="_blank" :href="currTab=='image'?scope.row.url:scope.row.cover_url">点击查看</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-radio-group>
      <el-pagination background layout="prev, pager, next"
        @current-change="(offset)=>{getMaterialList(currTab,offset-1)}" :page-size="20" :total="materialTotal">
      </el-pagination>
      <div style="margin-top: 20px;">
        <el-button @click="msgShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmMsg">选 取</el-button>
      </div>
    </el-dialog>


    <!-- <el-dialog
	  title="选取图文消息"
	  :visible.sync="newsMsgShow"
	  width="60%">
	  <el-radio-group key="news" v-model="currArticleId">
	  <el-table :data="newlList" :height="640">
	  	 <el-table-column
	  	      width="55">
			  <template slot-scope="scope">
				<el-radio :label="scope.row.article_id"></el-radio>
			  </template>
	  	    </el-table-column>
	  	 <el-table-column
	  		  label="名称"
			  width="300"
	  		  prop="name">
			  <template slot-scope="scope">
				 {{scope.row.content.news_item[0].title}}
			  </template>
	  	</el-table-column>
	  	 <el-table-column
	  		  label="操作"
	  		  width="120">
	  		  <template slot-scope="scope">
				  <div>
					  <a target="_blank" :href="scope.row.content.news_item[0].url">查看</a>
				  </div>
	  		  </template>
	  	</el-table-column>
	  </el-table>
	  </el-radio-group>
	  <el-pagination
	    background
	    layout="prev, pager, next"
	    @current-change="(offset)=>{getNewsList(offset-1)}"
	    :page-size="20"
	    :total="newsTaltol">
	  </el-pagination>
	  <div style="margin-top: 20px;">
	    <el-button @click="newsMsgShow = false">取 消</el-button>
	    <el-button type="primary" @click="confirmNewsMsg">选 取</el-button>
	  </div>
	</el-dialog> -->
  </div>
</template>

<script>
  import {
    Message,
    Loading,
    Notification,
    MessageBox
  } from 'element-ui'
  export default {
    name: 'HelloWorld',
    props: {
      msg: String
    },
    data() {
      return {
        // currLockPass:'12456Asv....',
        currLockPass: null,
        pageShow: false,
        msgShow: false,
        newsMsgShow: false,
        currTab: 'image',
        currMenu: {},
        materialInfo: {},
        materialList: [],
        materialTotal: 0,
        newlList: [],
        newTotal: 0,
        currMediaId: null,
        currArticleId: null,
        currSelectObject: null,
        menuTypes: [{
            name: '触发事件',
            value: 'click'
          },
          {
            name: '跳转页面',
            value: 'view'
          },
          // {
          // 	name:'scancode_push',
          // 	value:'scancode_push'
          // },
          // {
          // 	name:'scancode_waitmsg',
          // 	value:'scancode_waitmsg'
          // },
          // {
          // 	name:'pic_sysphoto',
          // 	value:'pic_sysphoto'
          // },
          // {
          // 	name:'pic_photo_or_album',
          // 	value:'pic_photo_or_album'
          // },
          // {
          // 	name:'pic_weixin',
          // 	value:'pic_weixin'
          // },
          // {
          // 	name:'location_select',
          // 	value:'location_select'
          // },
          {
            name: '发送消息',
            value: 'media_id'
          },
          // {
          // 	name:'图文消息',
          // 	value:'article_id'
          // },
          // {
          // 	name:'图文消息-卡片',
          // 	value:'article_view_limited'
          // },
          {
            name: '打开小程序',
            value: 'miniprogram'
          }
        ]
      }
    },
    created() {
      this.$prompt('请输入密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        this.currLockPass = value;
        this.initMenu(this.currLockPass);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });

      // this.initMenu(this.currLockPass);
    },
    methods: {
      initMenu(lockPass) {
        this.$http.get('menu/query?lockPass=' + lockPass).then(res => {
          if (!res) {
            this.$message.error('密码错误!');
            return;
          }
          this.pageShow = true;
          res.selfmenu_info.button.forEach(menu => {
            if (menu.sub_button) {
              menu.sub_button = menu.sub_button.list;
            }
          })

          this.currMenu = res.selfmenu_info;
        })
      },
      createMenu() {
        let loadingInstance = Loading.service({
          lock: true,
          text: '发布中,请稍后......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.currMenu.lockPass = this.currLockPass;
        this.$http.post('menu/create', this.currMenu).then(res => {
          loadingInstance.close();
          if (res == null) {
            this.$message.error('密码错误!');
            return;
          } else if (res.errcode) {
            this.$alert('发布失败,错误代码:' + res.errcode + ',错误消息:' + res.errmsg, '错误提示', {
              confirmButtonText: '确定',
            });
            return
          }
          this.$message.success('发布成功!');
        })
      },
      getMaterialInfo() {
        this.$http.get('menu/material/info').then(res => {
          if (res == null) {
            this.$message.error('获取错误!');
            return;
          }
          this.materialInfo = res;
        })
      },
      getMaterialList(type, offset = 0, count = 20) {
        this.$http.get('menu/material/list?type=' + type + '&offset=' + offset + '&count=' + count).then(res => {
          this.materialList = res.item;
          this.materialTotal = res.total_count;
        })
      },
      // getNewsList(offset=0,count=20){
      //  this.$http.get('menu/freepublish/list?offset='+offset+'&count='+count).then(res=>{
      //   this.newlList=res.item;
      //   this.newTotal=res.total_count;
      //  })
      // },
      selectMsg(menu) {
        this.currSelectObject = menu;
        this.getMaterialInfo();
        this.getMaterialList('image');
        this.currTab = 'image';
        this.msgShow = true;
      },
      // selectNewsMsg(menu){
      //  this.currSelectObject=menu;
      //  this.getMaterialInfo();
      //  this.getNewsList('news');
      //  this.newsMsgShow=true;
      // },
      confirmMsg() {
        this.currSelectObject.media_id = this.currMediaId;
        this.msgShow = false;
      },
      // confirmNewsMsg(){
      //  this.currSelectObject.article_id=this.currArticleId;
      //  this.newsMsgShow=false;
      // },
      addMenu() {
        if (!this.currMenu.button) {
          this.currMenu['button'] = [];
          this.currMenu.button.push({
            type: '',
            name: '',
            url: '',
            key: '',
            media_id: ''
          })
        } else if (this.currMenu.button.length < 3) {
          this.currMenu.button.push({
            type: '',
            name: '',
            url: '',
            key: '',
            media_id: ''
          })
        } else {
          this.$message.warning('一级菜单不能超过3个');
        }
        this.$forceUpdate();
      },
      addSubMenu(currMenu) {
        currMenu['type'] = null;
        if (!currMenu.sub_button) {
          currMenu['sub_button'] = [];
          currMenu.sub_button.push({
            type: '',
            name: '',
            url: '',
            key: '',
            media_id: ''
          })
        } else if (currMenu.sub_button.length < 5) {
          currMenu.sub_button.push({
            type: '',
            name: '',
            url: '',
            key: '',
            media_id: ''
          })
        } else {
          this.$message.warning('子菜单不能超过5个');
        }
        this.$forceUpdate();
      },
      delMenu(menu, index) {
        menu.splice(index, 1);
        this.$forceUpdate();
      }
    }
  }
</script>
<style scoped>
  .page_context {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .menu_context {
    width: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }


  .item_list {
    display: flex;
    flex-direction: column;
  }

  .sub_item_list {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }

  .item_row {
    display: flex;
    flex-direction: row;
    margin-bottom: 6px;
  }

  .btn_icon {
    margin-left: 6px;
    margin-right: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .select_type {
    width: 120px;
    margin-right: 6px;
  }

  .input_name {
    width: 180px;
    margin-right: 6px;
  }

  .select_icon {
    margin-right: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .input_url {
    width: 380px;
  }

  .opr_btn {
    display: flex;
    flex-direction: row;
    gap: 30px;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue